import styled from 'styled-components';

export const FlexStart = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;
